import { useState } from "react";
import { Link } from "react-router-dom";
import { Lightbox } from "@/components/Lightbox";
import { BeforeAfter } from "@/components/BeforeAfter";
import { responsive } from "@/lib/media";

export function GalleryPreview({ items }) {
  const [open, setOpen] = useState(null);
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
        <div>
          <span className="dg-eyebrow">Past work</span>
          <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold font-display tracking-tight">Real hands-on experience, now on call.</h2>
        </div>
        <Link to="/gallery" className="dg-link text-sm" data-testid="gallery-more">Open gallery →</Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        {items.map((p, i) => (
          <div key={p.src} className={`dg-card rounded-xl overflow-hidden dg-reveal dg-reveal-${(i % 4) + 1}`} data-testid={`gallery-preview-${i}`}>
            {p.before ? (
              <BeforeAfter before={p.before} after={p.src} alt={p.title} className="h-56" onTap={() => setOpen(i)} />
            ) : (
            <button type="button" onClick={() => setOpen(i)} className="block w-full h-56 overflow-hidden cursor-zoom-in text-left" aria-label={`Open ${p.title}`} data-testid={`gallery-preview-open-${i}`}>
              <img {...responsive(p.src)} alt={p.title} loading="lazy" decoding="async" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
            </button>
            )}
            <div className="p-4 flex items-center justify-between gap-2">
              <div className="text-sm text-slate-200">
                {p.id ? <Link to={`/project/${p.id}`} className="hover:text-cyan-300 transition-colors" data-testid={`gallery-preview-link-${i}`}>{p.title}</Link> : p.title}
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                {p.installed && <span className="dg-chip text-[#FFD600] border-[#FFD600]/50">Installed by David</span>}
                <span className="dg-chip">{p.tag}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Lightbox items={items} index={open} onClose={() => setOpen(null)} onChange={setOpen} />
    </section>
  );
}
